<template>
  <div class="info-window">
    <p class="text-royal-tree" v-if="royalTree">ต้นไม้พระราชทาน</p>
    <v-lazy-image class="info-img" :src="imageUrl" :src-placeholder="imageUrl" />
  </div>
</template>

<script>
// import VLazyImage from "v-lazy-image"
export default {
  // components: {
  //   VLazyImage
  // },
  props: {
    royalTree: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
  .info-img {
    width: 100%;
    max-width: 250px;
  }
  .text-royal-tree {
    color: #cdac4c;
    font-weight: bold;
    font-size: 1.2em;
    margin-bottom: 0;
  }

</style>
